import { BaseUpdateComponent, BaseDataService, InputComponent, QueryParameter, NumberInputComponentV3, UserService, ModalService, NotificationService, ErrorHandlerService, ConfirmationDialogButtons, BaseInlineContainer } from 'yt-ng-framework';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { EOtpremnicaStavka } from './eotpremnica-stavka';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EOtpremnicaService } from './eotpremnica-service';
import { DecimalPipe } from '@angular/common';
import { Observable, of, Subject, Subscription } from 'rxjs';
import * as var_config from '../../var_config';
import { List } from 'immutable';
import { RobaView } from 'src/app/lookups/roba/roba-view';
import { HttpErrorResponse } from '@angular/common/http';
import { AkciznaRobaTipPakovanjaView } from 'src/app/lookups/akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja-view';
import { AkciznaRobaTipPakovanja } from 'src/app/lookups/akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja';
import { AbstractControl, Validators } from '@angular/forms';
import { requireTipPakovanjaIfNeeded } from '../_validators/require-tip-pakovanja-if-needed.validator';

@Component({
  selector: 'yt-eotpremnica-stavka-update',
  templateUrl: './eotpremnica-stavka-update.component.html',
  styleUrls: ['./eotpremnica-stavka-update.component.scss']
})
export class EOtpremnicaStavkaUpdateComponent
  extends BaseUpdateComponent<EOtpremnicaStavka>
  implements OnInit, OnDestroy {

  izlazna: boolean = false;
  private destroy$ = new Subject<void>();
  varConfig = var_config;
  robaItems: List<RobaView>;

  trebaTipPakovanja: boolean = false;
  trebaTipPakovanjaDDL: boolean = false;
  trebaVrednost: boolean = false;
  trebaSifraRobneMarke = false;
  parameterListZaKategoriju: List<QueryParameter> = List([]);
  razvoj: boolean = false;

  showDodatniAtributi: boolean = false;
  brojDodatnihAtributa: number = 0;


  @ViewChild('tipPakovanjaVrednost2') tipPakovanjaVrednost2: NumberInputComponentV3;

  // @ViewChild('baseUpdate', { static: false })
  // baseUpdate: any;

  //@ViewChild('baseInlineContainer1', { static: false }) baseInlineContainer1;

  // @ViewChild('nestedInline', {static: false}) nestedInline :any;
  @ViewChild('nestedInlineContainer', {static: false}) nestedInlineContainer :BaseInlineContainer<EOtpremnicaStavka>;
  
  @ViewChild(BaseUpdateComponent, { static: false })
  public base: BaseUpdateComponent<EOtpremnicaStavka>;
  // @ViewChild(BaseUpdateComponent, { static: false })
  // base: BaseUpdateComponent<EOtpremnicaStavka>;

  pretplacenNaPromene: boolean = false;
  private vrednostValueChangeSubscription: Subscription;
  private isSyncingValue = false;
  private lastSelectedRobaId: number = null;
  private lastSelectedAkciznaRobaId: number = null;
  private lastSelectedAkciznaRoba: string = null;
  private shouldAutoSelectTipPakovanjaAfterCategoryChange: boolean = false;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected otpremnicaService: EOtpremnicaService,
    protected decimalPipe: DecimalPipe,
    protected userService: UserService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected modalService: ModalService,
    protected errorService: ErrorHandlerService

  ) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService);

  }


  ngOnInit() {
    super.ngOnInit();
    this.parameterListZaKategoriju = List([]);

    // this.izlazna=this.modelData.MainList.ModelName=="EOtpremnicaStavka";
    if (this.Parameters && this.Parameters.get(1))
      this.izlazna = Boolean(this.Parameters.get(1).get(0).Value);


    this.baseFormGroup.setValidators([
      this.baseFormGroup.validator,
      requireTipPakovanjaIfNeeded(
        'AkciznaRoba',
        'AkciznaRobaTipPakovanjaID',
        'AkciznaRobaTipPakovanja'
      )

    ].filter(fn => typeof fn === 'function'));

    this.addValidatorToFc('RobaID'
      , Validators.required
      , 'required'
      , 'EOTPREMNICASTAVKA.ROBA.VALIDATION.REQUIRED'
    );
    this.addValidatorToFc('Kolicina'
      , Validators.required
      , 'required'
      , 'EOTPREMNICASTAVKA.KOLICINA.VALIDATION.REQUIRED'
    );
    this.addValidatorToFc(
      'Kolicina',
      Validators.min(0.0000001),
      'min',
      'EOTPREMNICASTAVKA.KOLICINA.VALIDATION.MIN'
    );

    this.baseFormGroup.updateValueAndValidity({ emitEvent: false });

    this.IDProcessed
      .subscribe((value) => {
        if (!Boolean(this.Parameters.get(1).get(0).Value)) {
          this.baseFormGroup.disable();
          this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
        }

        this.TransferParameters = this.TransferParameters.set(
            0,
            List([new QueryParameter('Lock', !this.Item.Editable)])
        );
        
        this.getRbr();
        if (!this.pretplacenNaPromene) {
          this.pretplacenNaPromene = true;
          this.vrednostValueChangeSubscription =
            this.baseFormGroup.get("AkciznaRobaTipPakovanjaVrednost")
              .valueChanges
              .subscribe((value) => {
                if (!value)
                  return;
                
                // spreči rekurziju
                if (this.isSyncingValue) return;

                if (this.tipPakovanjaVrednost2) {
                  this.isSyncingValue = true;
                  this.tipPakovanjaVrednost2.writeValue(value);
                  this.isSyncingValue = false;
                }
              });
        }
        const akc = (this.baseFormGroup.get('AkciznaRoba')?.value ?? '').trim().toUpperCase();
        const isAkcizna = akc !== '' && akc !== 'NIJE AKCIZNA ROBA';
        const isDuvan = isAkcizna && akc === 'DUVAN';
        const isNikotin = isAkcizna && akc === 'NIKOTIN';

        if (this.izlazna)
          this.setAkciznaControlsState(isAkcizna, isDuvan, isNikotin, false);
        
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);

        if (value && this.Item?.ID == -1)
          this.baseFormGroup.enable();


        // U praksi neke kontrole (picklist, date/time, itd.) umeju da na inicijalnom bind-u
        // programatski normalizuju vrednosti u formi, pa FW canDeactivate() pogrešno prijavi izmene.
        // Posle inicijalnog load-a postojeće stavke osveži snapshot i vrati formu u pristine.
        if (value && this.Item?.ID > 0) {
          this.showDodatniAtributi = false;
          this.refreshSavedState();
        }
         if (value && this.Item?.ID == -1) {
          this.showDodatniAtributi = false;

        }
        this.lastSelectedRobaId = this.baseFormGroup.get('RobaID')?.value ?? null;
        this.lastSelectedAkciznaRobaId = this.baseFormGroup.get('AkciznaRobaID')?.value ?? null;
        this.lastSelectedAkciznaRoba = this.baseFormGroup.get('AkciznaRoba')?.value ?? null;

      })


  }

  ngAfterViewInit(){
    super.ngAfterViewInit();
    
  }
  getRbr() {
    if (this.Item.ID == -1 && this.ParentProperty && this.ParentProperty.Value) {
      let EOtpremnicaID = this.ParentProperty.Value;
      this.baseDataService.Get('EOtpremnicaStavka'
        , 'GetNextItemNumByEOtpremnicaID'
        , [new QueryParameter('eotpremnicaID', EOtpremnicaID)]
        , null)
        .subscribe(data => {
          this.baseFormGroup.get('RedniBroj').patchValue(data);
          this.baseFormGroup.get('RedniBroj').updateValueAndValidity();
        },
          error => {
            if (error instanceof HttpErrorResponse) {
              let _message;
              _message = this.errorService.getServerMessage(error);

              this.translateService.get(_message)
                .subscribe(translate => {
                  this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translate, "warning", ConfirmationDialogButtons.Ok);
                  this.ResetValues(true, false);
                });
            }
          }
        )

    }
  }


  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.vrednostValueChangeSubscription) {
      this.vrednostValueChangeSubscription.unsubscribe();
    }
    this.destroy$.next(); // Emituje signal za završetak pretplata
    this.destroy$.complete(); // Završava Subject
  }

  RobaGetItems(items) {
    this.robaItems = items;
  }

  AkciznaRobaTipPakovanjaGetItems(items) {
    if (this.baseFormGroup.get('AkciznaRobaTipPakovanjaID').disabled) return;

    if (this.Item.ID == -1 || this.shouldAutoSelectTipPakovanjaAfterCategoryChange) {
      if (items.size == 1) {
        this.baseFormGroup.get("AkciznaRobaTipPakovanjaID")?.patchValue(items.get(0).ID);
      // } else {
      //   this.baseFormGroup.get("AkciznaRobaTipPakovanjaID")?.patchValue(null);
      }
      this.baseFormGroup.get('AkciznaRobaTipPakovanjaID').updateValueAndValidity();
      this.shouldAutoSelectTipPakovanjaAfterCategoryChange = false;
    }
  }

  onRobaSelect(value: RobaView) {
    const previousRobaId = this.lastSelectedRobaId;
    const previousAkciznaRobaId = this.lastSelectedAkciznaRobaId;
    const previousAkcizna = (this.lastSelectedAkciznaRoba ?? '').trim().toUpperCase();
    const nextAkcizna = (value?.AkciznaRoba ?? '').trim().toUpperCase();
    const nextAkciznaRobaId = value?.AkciznaRobaID ?? null;
    const robaChanged = previousRobaId != null && value?.ID !== previousRobaId;
    const categoryChanged = previousAkcizna !== nextAkcizna || previousAkciznaRobaId !== nextAkciznaRobaId;

    if (robaChanged || categoryChanged) {
      this.baseFormGroup.get("AkciznaRobaTipPakovanjaID")?.patchValue(null, { emitEvent: false });
      this.baseFormGroup.get("AkciznaRobaTipPakovanja")?.patchValue(null, { emitEvent: false });
      this.baseFormGroup.get("AkciznaRobaTipPakovanjaVrednost")?.patchValue(null, { emitEvent: false });
      this.baseFormGroup.get("AkciznaRobaSifraRobneMarke")?.patchValue(null, { emitEvent: false });
      this.shouldAutoSelectTipPakovanjaAfterCategoryChange = true;
    }

    // const selektovanaRoba = this.robaItems.find(x => x.ID === this.baseFormGroup.get("RobaID")?.value);
    // if (selektovanaRoba) {
    if (value){
      this.baseFormGroup.get("Sifra")?.patchValue(value.Sifra);
      this.baseFormGroup.get("Naziv")?.patchValue(value.Naziv);
      this.baseFormGroup.get("JedinicaMere")?.patchValue(value.UnitOfMeasureCode);
      this.baseFormGroup.get("JedinicaMereNaziv")?.patchValue(value.UnitOfMeasure);
      if (value.AkciznaRoba && value.AkciznaRoba.toUpperCase() != "NIJE AKCIZNA ROBA") {
        this.baseFormGroup.get("AkciznaRoba")?.patchValue(value.AkciznaRoba);
        this.trebaTipPakovanja = true;
        this.trebaTipPakovanjaDDL = value.AkciznaRoba != 'NIKOTIN';
        this.trebaVrednost = value.AkciznaRoba != 'NIKOTIN' && value.AkciznaRoba != 'DUVAN';
        // Akcizna vrednost se unosi samo za akciznu robu koja nije duvan
        // Šifra robne marke samo ako je duvan u pitanju
        this.baseFormGroup.get("AkciznaRobaSifraRobneMarke")?.patchValue(value.AkciznaRobaSifraRobneMarke);
      } else {
        this.baseFormGroup.get("AkciznaRobaTipPakovanjaID")?.patchValue(null);
        this.baseFormGroup.get("AkciznaRobaTipPakovanja")?.patchValue(null);
        this.baseFormGroup.get("AkciznaRoba")?.patchValue(null);
        this.baseFormGroup.get("AkciznaRobaTipPakovanjaVrednost")?.patchValue(null);
        this.baseFormGroup.get("AkciznaRobaSifraRobneMarke")?.patchValue(null);
        this.trebaTipPakovanja = this.izlazna ? true : false;
        this.trebaTipPakovanjaDDL = this.izlazna ? true : false;
        this.trebaVrednost = this.izlazna ? true : false;
        this.trebaSifraRobneMarke = this.izlazna ? true: false;
      }
      this.baseFormGroup.updateValueAndValidity();

      // this.baseFormGroup.get('AkciznaRobaTipPakovanjaVrednost').updateValueAndValidity();

      // }

      this.parameterListZaKategoriju = List([new QueryParameter('akciznaRobaId', value.AkciznaRobaID)]);

      const akc = (value?.AkciznaRoba ?? '').trim().toUpperCase();
      const isAkcizna = akc !== '' && akc !== 'NIJE AKCIZNA ROBA';
      const isDuvan = isAkcizna && akc === 'DUVAN';
      const isNikotin = isAkcizna && akc === 'NIKOTIN';

    this.setAkciznaControlsState(isAkcizna, isDuvan, isNikotin, true);
    this.lastSelectedRobaId = value?.ID ?? null;
    this.lastSelectedAkciznaRobaId = nextAkciznaRobaId;
    this.lastSelectedAkciznaRoba = value?.AkciznaRoba ?? null;

  }
  }

  onTipPakovanjaSelect(value: AkciznaRobaTipPakovanjaView) {
    if (value){
      this.baseFormGroup.get("AkciznaRobaTipPakovanja")?.patchValue(value.Naziv);
      this.baseFormGroup.updateValueAndValidity();
    }
    //   this.baseFormGroup.get("AkciznaRobaTipPakovanja")?.patchValue(value.Naziv);
    // else
    //   this.baseFormGroup.get("AkciznaRobaTipPakovanja")?.patchValue(null);
    // this.baseFormGroup.updateValueAndValidity();

  }

  // Save() {
  //   super.SaveItem();
  // }
  Save() {
    // forsiraj da se validator preračuna
    this.baseFormGroup.updateValueAndValidity({ emitEvent: false });

    console.log('FORM STATUS:', this.baseFormGroup.status);
    console.log('FORM ERRORS:', this.baseFormGroup.errors);

    Object.keys(this.baseFormGroup.controls).forEach(k => {
      const c = this.baseFormGroup.get(k);
      if (c && c.invalid) {
        console.log('INVALID:', k, 'errors=', c.errors, 'value=', c.value, 'disabled=', c.disabled);
      }
    });

    super.SaveItem();
  }


  onToggleDodatniAtributi() {
    if (this.showDodatniAtributi && this.nestedInlineContainer) {
      // this.nestedInlineContainer.SetDetailModelData(
      //   this.modelData.MainList.DetailList[3]
      // );
    }
  }

  Reset(loadItem?: boolean): Observable<boolean> {
    return super.Reset(loadItem);
  }


  private setAkciznaControlsState(isAkcizna: boolean, isDuvan: boolean, isNikotin: boolean, clearValues: boolean): void {
    const tip = this.baseFormGroup.get('AkciznaRobaTipPakovanjaID');
    const vred = this.baseFormGroup.get('AkciznaRobaTipPakovanjaVrednost');
    const sif = this.baseFormGroup.get('AkciznaRobaSifraRobneMarke');
    const tipTxt = this.baseFormGroup.get('AkciznaRobaTipPakovanja');

    if (!isAkcizna) {
      if (clearValues) {
        tip?.patchValue(null, { emitEvent: false });
        vred?.patchValue(null, { emitEvent: false });
        sif?.patchValue(null, { emitEvent: false });
      }
      tip?.disable({ emitEvent: false });
      vred?.disable({ emitEvent: false });
      sif?.disable({ emitEvent: false });
      return;
    }

    tip?.enable({ emitEvent: false });

    if (isDuvan) {
      if (clearValues) {
        vred?.patchValue(null, { emitEvent: false });
      }
      vred?.disable({ emitEvent: false });
      sif?.enable({ emitEvent: false });
    } else {
      if (clearValues) {
        sif?.patchValue(null, { emitEvent: false });
      }
      sif?.disable({ emitEvent: false });
      vred?.enable({ emitEvent: false });
    }

    if (isNikotin) {
      if (clearValues) {
        vred?.patchValue(null, { emitEvent: false });
      }
      vred?.disable({ emitEvent: false });
      sif?.disable({ emitEvent: false });
      if (clearValues) {
        tip?.patchValue(null, { emitEvent: false });
        tipTxt?.patchValue(null, { emitEvent: false });
        vred?.patchValue(null, { emitEvent: false });
        sif?.patchValue(null, { emitEvent: false });
      }
    }
  }



}

